import React from 'react';
import './Footer.css';

import { Logo} from '../../components';
import { contactContent, services } from '../../constants'; 

import { FaFacebookF, FaInstagram, FaLeaf } from 'react-icons/fa';

import { Link } from 'react-router-dom'; 
import { useTranslation } from 'react-i18next';
 
const Footer = () => {   

  const { t } = useTranslation();
  
  return (
    <footer className='footer'>
      
      <div className='box-container'>

        <div className='footer-item'>

          <Logo /> 
          <p>{t('footer.description', 'Fundacja Dwór Imielno - Centrum Kultury Obszarów Wiejskich, Edukacji Ekologicznej i Zachowania Różnorodności Biologicznej')}</p>

          <div className='info connect'>
            {contactContent
              .filter(contact => contact.id !== 4) 
              .map((contact) => {
                return (
                  <p key={contact.id}>
                    <span className='icon'>{contact.icon}</span>
                    {contact.content[0]}
                  </p>
                );
              })}
          </div>

          <div className='social'>
            <a href="https://www.facebook.com/profile.php?id=61584478547291&locale=pl_PL"><FaFacebookF className='icon' /></a>    
            <a href="https://www.instagram.com/dwor.imielno?igsh=cmkxM2M0bWR0cTZj"><FaInstagram className='icon' /></a>
          </div>

        </div>

        <div className='footer-item'> 

          <h2>{t('footer.offerTitle', 'Oferta')}</h2>

          <div className='info links'> 
            {services.map(service => {
              return (
                <p key={service.id}><FaLeaf className='icon' /> 
                  <Link
                    to={`/Uslugi/${service.id}`}
                    state={service} 
                  >
                    {service.titleKey ? t(service.titleKey) : service.title}  
                  </Link>
                </p>
              )
            })}
          </div>
        </div>

        <div className='footer-item'> 
          <h2>{t('footer.quickLinks', 'Szybkie linki')}</h2>

          <div className='info links'> 
            <p><FaLeaf className='icon' /><Link to='/O-nas'>{t('navbar.about', 'O nas')}</Link></p>
            <p><FaLeaf className='icon' /><Link to='/Uslugi'>{t('navbar.offer', 'Usługi')}</Link></p>
            <p><FaLeaf className='icon' /><Link to='/Skontaktuj-sie'>{t('navbar.contact', 'Kontakt')}</Link></p>
          </div>

        </div>

      </div>
 
      <div className='content'>
        {/* Tłumaczenie dolnej części stopki */}
        <p>{t('footer.designedBy', 'zaprojektowane przez')} <span>Edyta Szymańska</span> | {t('footer.rightsReserved', 'wszelkie prawa zastrzeżone')}</p>
      </div>
      
    </footer>
  )
}

export default Footer;